module.exports = __webpack_public_path__ + "static/media/anc1kz.2db0c8e0.pdf";